import React from 'react';

export default ({ label, name, className, children, errors = false, ...props }) => {
    return (
        <div className={className}>
            {label && (
                <label htmlFor={name} className="block text-sm font-medium text-gray-100">
                    {label}
                </label>
            )}
            <select
                id={name}
                name={name}
                {...props}
                className={`appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 sm:text-sm`}>
                {children}
            </select>
        </div>
    );
};
